import {
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { BehaviorSubject, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AppService } from '../services/app.service';

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<string | null>(null);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const apiService = inject(ApiService);
  const router = inject(Router);
  const appService = inject(AppService);

  let token = storageService.getAccessToken();
  let refreshToken = storageService.getRefreshToken();

  let reqClone;
  if ([req.url.includes('/refresh-token'), req.url.includes('/logout')].includes(true)) {
    reqClone = req.clone({
      headers: req.headers.set(
        'Authorization',
        refreshToken ? `Bearer ${refreshToken}` : ''
      ),
    });
  } else {
    reqClone = req.clone({
      headers: req.headers.set('Authorization', token ? `Bearer ${token}` : ''),
    });
  }

  return next(reqClone).pipe(
    catchError((error) => {
      if (error.status === 401) {
        if (isRefreshing) {
          return refreshTokenSubject.pipe(
            filter((token): token is string => token !== null),
            take(1),
            switchMap((newToken) => {
              const retryReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${newToken}`),
              });
              return next(retryReq);
            })
          );
        }

        isRefreshing = true;
        refreshTokenSubject.next(null);

        return apiService.getNewAccessToken().pipe(
          switchMap((response: any) => {
            isRefreshing = false;
            storageService.setAccessToken(response.access_token);
            refreshTokenSubject.next(response.access_token);

            const newReq = req.clone({
              headers: req.headers.set(
                'Authorization',
                `Bearer ${response.access_token}`
              ),
            });

            return next(newReq);
          }),
          catchError((refreshError) => {
            isRefreshing = false;
            refreshTokenSubject.next(null);
            appService.updateAppLoginState(false);
            router.navigate(['/login']);
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
